<template>
  <div class=''>
      <div class="img_box">
          <img src="../assets/img/bangzhu1.png" @click="gotopathKe()" alt="" class="bangzhu">
          <img src="../assets/img/kefu_a.png" @click="gotopath()" alt="" class="kefu">
      </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'

export default {
  name: 'kefu',
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props:{
      sn:String
  },
  data () {
    // 这里存放数据
    return {

    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    gotopath(){
      this.$router.push({ path: "/service", query: { sn: this.sn } });
    },
    gotopathKe(){
      this.$router.push({ path: "/help", query: { sn: this.sn } });
    }
  }
}
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类
// .img_box{
//     position: fixed;
//     right: 14px;
//     bottom: 150px;
//     img{
//         width: 67px;
//         height: 67px;
//     }
// }
.bangzhu{
    width: 1.125rem;
    height: 1.125rem;
    margin-right: .625rem;
    transform: translateY(3px);
}
.kefu{
  width: 1.0938rem;
  height: 1.0625rem;
  transform: translateY(3px);
}
.mg_l{
  margin-left: 13px;
}
</style>
